export const FONT_PRIMARY = 'Source Sans Pro';

export const ANIMATION = '0.2s ease';
